export function initItemDocumentsRowClick() {
    for (const row of document.querySelectorAll('.itemtable--documents .itemtable__row:not(.itemtable__row--header)')) {
        const action = row.querySelector('.itemtable__cell--actions a, .itemtable__cell--actions form');
        if (!action) {
            continue;
        }
        row.addEventListener('click', (event) => {
            if (event.target.closest('a, button')) {
                return;
            }
            if (action.tagName === 'FORM') {
                action.submit();
            } else {
                action.click();
            }
        });
    }
}
